// AUTH TYPES
export const SET_LOGIN = "SET_LOGIN";
export const UNSET_LOGIN = "UNSET_LOGIN";
